<template>
  <div class="step1-container">
    <div class="title">慧策账号密码找回</div>
    <div class="form">
			
			<el-alert
				:type="formData.errorMsg ? 'error' : 'info'"
				:title="formData.errorMsg"
				:closable="false"
				style="height: 32px"
			/>

			<el-input
				v-model="formData.tenantId"
				placeholder="卖家账号(用手机找回可不填)"
				size="large"
				class="input-item"
				clearable
				@input="handleTenantIdInput"
			/>

			<el-input
				v-model="formData.account"
				placeholder="手机号/昵称"
				size="large"
				class="input-item"
				clearable
				@input="handleAccountInput"
			/>

			<el-button
				type="primary"
				size="large"
				style="width: 400px"
				@click="onSubmit"
				>下一步
			</el-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive } from 'vue'
import { catchError } from '@/utils'
import { UserInfoForRetrievePassword } from 'types/api'
import { queryForRetrievePassword } from '@/api/retrieve'

const props = defineProps<{
  next: (userInfo: UserInfoForRetrievePassword) => void,
	fail: ()  => void
}>()

const formData = reactive({
  tenantId: '',
  account: '',
  errorMsg: '',
})

const handleTenantIdInput = (val) => {
  formData.errorMsg = ''
  if (!val) return
  formData.tenantId = formData.tenantId.replace(/(^\s*)|(\s*$)/g, '')
}

const handleAccountInput = (val) => {
  formData.errorMsg = ''
  if (!val) return
  formData.account = formData.account.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * 提交
 */
const onSubmit = async () => {
  if(!formData.account) {
		formData.errorMsg = '请输入手机号/帐号';
		return;
	}

	const { response, error } = await catchError(
    queryForRetrievePassword(
      {
        account: formData.account,
        tenantId: formData.tenantId,
      }
    )
  )

  if (error) {
    return;
  }
	
	if (response?.code) {
		switch(response.code) {
			case 100010:
				formData.errorMsg = '请填写卖家账号'
				return;
			case 100041:
				if(!formData.tenantId) {
					formData.errorMsg = '手机号不唯一, 请填写卖家账号'
					return;
				}
			case 100005:
				props.fail();
				return;
		}
    
    formData.errorMsg = response?.message as string
    return
  }

	props.next(response!.data);
}

</script>
<style lang="scss" scoped>
.step1-container {
  text-align: center;
  .title {
    font-size: 24px;
    font-weight: 600;
  }

  .form {
    display: flex;
		flex-direction: column;
    padding-top: 30px;

		:deep(.el-alert) {
			margin-bottom: 4px;
		}

		:deep(.el-alert--info) {
			background-color: transparent;
		}

		& > * {
			width: 400px;
			height: 32px;
			--el-input-height: 30px;
			margin-bottom: 24px;
			place-self: center;
		}

    // .form-inline {
    //   @media screen and (orientation: portrait) {
    //     width: 300px;
    //   }
    //   .input-item {
    //     width: 400px;
    //   }
    // }
  }
}
</style>
